import { render, staticRenderFns } from "./createSocialLinkModal.vue?vue&type=template&id=6736741b&scoped=true"
import script from "./createSocialLinkModal.vue?vue&type=script&lang=js"
export * from "./createSocialLinkModal.vue?vue&type=script&lang=js"
import style0 from "./createSocialLinkModal.vue?vue&type=style&index=0&id=6736741b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6736741b",
  null
  
)

export default component.exports